import pkgJSON from '../../../package.json';
import {getEnvironment, getParsedUserAgent, isLocalhost } from "../util/index";
import TimeService from "../services/timeService";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {ValidationResponse, ValidationResponseCheck } from '@npd-ng/adp-types';
import { IADPState, AppConfigExtended, Content, Views, ManifestProps, ServiceWorkerType, PreCacheVaidationStatus, NetworkConnectionState, NetworkConnectionStateObj, VerifySetUpCodeResponse, ValidationState, IValidationSummary, UpdateComponents, Battery, SessionDetails, IpcMessageType, DeviceVitalsInfo, CachedType, AppMode, FailureType, eNAEPComponents, RelaunchInformationType, LaunchErrorType } from '../typings/AppStateTypes';
import { Manifest, checkStatus } from '../typings/ServiceTypes';
export const initialState: IADPState = {
    appState: {
        appLaunchId: undefined,
        appLaunchTime: new Date().toISOString(),
        appVersion: pkgJSON?.version,
        appCode: pkgJSON?.name,
        appBuildDate:undefined,
        releaseVersion: undefined,
        releaseBuildNumber: 0,
        releaseColors: [],
        releaseBorder: [],
        environment: getEnvironment(),
        configuration: undefined,
        currentView: "LoadingView",
        appPhases: [],
        currentPhase: "ResolvingLaunchMode",
        isPageReloaded: false,
        apiDomain: '',
        serviceWorkersRegistered: false,
        resourcesLoaded:false,
        extensionVersion: undefined,
        expectedADCVersion: undefined,
        expectedSCIVersion: undefined,
        expectedADPVersion: undefined,
        isUnderMaintenance: false,
        runtimePlatform: {
            platform: "Browser",
            version: "",
            userAgent: getParsedUserAgent().ua,
        },
        selectedLanguage: TimeService.timeZone() === "America/Puerto_Rico" ? "es" : "en",
        isCached: "Pending",
        launchMode: "NotResolved"
    },
    updateState: {
        isCheckForUpdateEnabled:true,
        appComponentVersions:[],
        status: "NotStarted",
    },
    cacheValidation:{
        validationStatus: "NotStarted",
    },
    serviceWorkers:[
        {appCode: eNAEPComponents.ADC},
        {appCode: eNAEPComponents.ADP},
        {appCode: eNAEPComponents.SCI}, 
    ],
    deviceState: {
        batteryState: {
            level: 100,
            charging: false
        },
        deviceId: undefined,
        deviceIdType: "NotAvailable",
        deviceType: "SBE",
        deviceModel: undefined,
        isDateTimeValid: false,
        //@ts-ignore
        browserAgentData:{
            //@ts-ignore
            brands: navigator?.userAgentData?.brands,//@ts-ignore
            mobile:navigator?.userAgentData?.mobile,//@ts-ignore
            platform: navigator?.userAgentData?.platform //@ts-ignore
        }
    },
    sessionState: {
        selectedAssessmentMode: "notselected",
        appAccessedFor: "NotSelected",
        connectionType: "Internet",
        networkConnectionState: navigator?.onLine ? "Connected" : "N/A",
        networkChangeEvents:[],
        schoolDetails: undefined,
        lastKnownGoodState: undefined,
        providedCode:undefined,
        selectedAssessmentLocation:undefined,
        locationError:false,
        homeButtonEnabled: false,
        exitButtonEnabled: true,
        confirmationModal: false,
        tryAgainAfterFailure: false
    },
    deviceReadinessState: {
      validationState: undefined
    },
    deviceReadinessSummary:undefined,
    staticContent: undefined,
    currentLanguageContent: undefined
};
export const reducerSlice = createSlice({//TODO implement thunk for indexdb
    name:'rootState',
    initialState:initialState,
    reducers:{
        createSetMaintenance (state:IADPState,action:{type: string,payload: boolean}){
          state.appState.isUnderMaintenance = action.payload
        },
        createSetLaunchMode (state:IADPState,action:{type:string,payload: IADPState["appState"]["launchMode"]}){
          state.appState.launchMode = action.payload;  
        },
        createRedirectToSCI(state:IADPState){
            if(state.sessionState.failure){
                return;
            }
            state.appState.currentView = "RedirectionView";
            state.sessionState.lastKnownGoodState = "RedirectionView";
        },
        createSetDateTimeCheck(state:IADPState,action:{type:string,payload:boolean}){
            state.deviceState.isDateTimeValid  = action.payload
        },
        createSetResourcesLoaded(state:IADPState,action:{type:string,payload:boolean}){
            state.appState.resourcesLoaded  = action.payload
        },
        createSetConfigAction(state:IADPState,action:{type:string,payload:AppConfigExtended}){
            const payload = action.payload;
            state.appState.configuration = payload
        },
        createSetContentAction(state:IADPState,action:{type:string,payload:{en:Content,es:Content}}){
            const payload = action.payload;
            state.staticContent = payload
            state.currentLanguageContent = TimeService.timeZone() === "America/Puerto_Rico" ? payload.es : payload.en
        },
        createSetInitialStateAction(state:IADPState,action: PayloadAction<IADPState>){
           return action.payload;
        },
        createSetViewAction(state:IADPState,action:{type:string,payload:Views}){
            if(state.sessionState.failure){
                return;
            }
            state.sessionState.tryAgainAfterFailure = false;
                const payload = action.payload;
                const enableHomeScreens:Views[] = 
                [ 
                    "AccessCodeValidationView",
                    "DeviceValidationSuccessView",
                    "VerificationCodeValidationView",
                    "DeviceValidationFailureView", 
                ]
                const disableExitScreens:Views[] = 
                [ 
                    "UpdaterView",
                    "LoadingView",
                ]
                state.sessionState.exitButtonEnabled=!disableExitScreens.includes(payload);
                state.sessionState.homeButtonEnabled=enableHomeScreens.includes(payload);
                state.appState.currentView= payload
                const goodView:Views[] =[
                "ModeSelectionsView",
                "AccessCodeValidationView",
                "DeviceValidationSuccessView",
                "VerificationCodeValidationView",
                "RedirectionView",
                "DeviceValidationFailureView"
                ]
                goodView.includes(payload) ? state.sessionState.lastKnownGoodState = payload : undefined
        },
        createSetReleaseVersionAction(state:IADPState,action:{type:string,payload:Manifest}){
            const payload = action.payload;
            state.appState.releaseVersion= payload.manifest.product.version
        },
        createSetServiceWorkerRegAction(state:IADPState,action:{type:string,payload:boolean}){
            const payload = action.payload;
           state.appState.serviceWorkersRegistered = payload;
        },
        createSetUpdateManfiestAction(state:IADPState,action:{type:string,payload:{manifest:ManifestProps}}){
            const payload = action.payload;
            state.appState.releaseVersion= payload.manifest.product.version
            state.appState.releaseBuildNumber = payload.manifest.product.buildNumber
            state.appState.releaseColors = payload.manifest.product.versionColors
            state.appState.releaseBorder = payload.manifest.product.versionBorderColors
        },
        createUpdateServiceWorkerDetailsAction(state:IADPState,action:{type:string,payload:ServiceWorkerType}){
         if(state.serviceWorkers && state.serviceWorkers?.length > 0){
               const serviceWorker =  state.serviceWorkers.find((sw) => {
                return sw.appCode === action.payload.appCode 
            })
            const updatedSW = {...serviceWorker,...action.payload}
            state.serviceWorkers =[...state.serviceWorkers,updatedSW]
            }
           
        },
        createUpdatePreChacheValidationStatusAction(state:IADPState,action:{type:string,payload:PreCacheVaidationStatus}){
            if(state.sessionState.failure){
                return;
            }
            const payload = action.payload;
            let events = [...state.cacheValidation?.validationEvents|| []];
            events.push(payload)
            state.cacheValidation ={
                ...state.cacheValidation,
                validationStatus: action.payload.validationStatus,
                validationDetails: action.payload.validationDetails,
                validationEvents:events
            }   
            
        },
        createSetNetworkAction(state:IADPState,action:{type:string,payload:NetworkConnectionState}){
            const payload:NetworkConnectionState = action.payload;
            state.sessionState.networkConnectionState = payload;
            state.sessionState.tryAgainAfterFailure = false;
            if(payload === "Connected" && state.sessionState.lastKnownGoodState){
                state.appState.currentView = state.sessionState.lastKnownGoodState;  
            }
        },
        createSetNetworkDetails(state:IADPState,action:{type:string,payload:NetworkConnectionStateObj}){
            const events = [...state.sessionState.networkChangeEvents];
            events.push(action.payload)
            state.sessionState.tryAgainAfterFailure = false;
            state.sessionState=
                {
                    ...state.sessionState,
                    networkDetails: state.deviceState.deviceType === "NPE" ? action.payload : {...action.payload,SSID:undefined},
                    networkChangeEvents: events
                }
        },
        createUpdateProgressAction(state:IADPState,action:{type:string,payload:IpcMessageType}){
                state.updateState={
                    ...state.updateState,
                    updateEvents: action.payload
                }  
         },
         createUpdateStatusAction(state:IADPState,action:{type:string,payload:IADPState["updateState"]["status"]}){
            state.updateState={
                ...state.updateState,
                status: action.payload
            }  
     },
        createUpdateSchoolAction(state:IADPState,action:{type:string,payload:VerifySetUpCodeResponse | undefined}){
            if(action.payload === undefined){
             state.sessionState={
                        ...state.sessionState,
                        providedCode:state.sessionState?.providedCode,
                        schoolDetails: action.payload
                       }
            }
            else{
            state.sessionState={
                    ...state.sessionState,
                    providedCode:action.payload?.setupCode ?? action.payload?.verificationCode ?? state.sessionState?.providedCode,
                   }
                   if(action.payload.status!=="validating"){
                    state.sessionState.schoolDetails = action.payload
                   }
            }
        },
        createClearSchoolAction(state:IADPState){
            state.sessionState.providedCode = undefined
            state.sessionState.schoolDetails = undefined
            
        },
        createSetAssessmentModeAction(state:IADPState,action:{type:string,payload:AppMode}){
            if(state.sessionState.failure){
                return;
            }
            state.sessionState.appAccessedFor = action.payload
            state.sessionState.exitButtonEnabled=true;
            state.sessionState.homeButtonEnabled=true;
            state.sessionState.tryAgainAfterFailure = false;
            state.appState.currentView = action.payload === "Assess" ? "AccessCodeValidationView" : "VerificationCodeValidationView"
            state.sessionState.lastKnownGoodState = action.payload === "Assess" ? "AccessCodeValidationView" : "VerificationCodeValidationView"
            state.deviceReadinessState.deviceReadinessInfo ={
                deviceReadinessCheckPassed: false,
                state: 'ReadinessCheckInProgress',
                failureReason: [],
                readinessCheckStartedAt: new Date().toISOString(),
                readinessCheckCompletedAt: ""
            }
        },
        createValidationAction(state:IADPState,action:{type:string,payload:ValidationState}){
            if(action.payload){
                state.sessionState.exitButtonEnabled=true;
                state.sessionState.homeButtonEnabled=false;
            }
            else{
                state.sessionState.exitButtonEnabled=true;
                state.sessionState.homeButtonEnabled=true;
            }
            state.deviceReadinessState.validationState= action.payload;
            state.sessionState.tryAgainAfterFailure = false;
        },
        createSetDeviceReadinessSummary(state:IADPState,action:{type:string,payload:(ValidationResponse & checkStatus)[]}){
            const results = action.payload;
            const failedChecks = results.filter(result => !result.isCheckPassed && result.type === ValidationResponseCheck.HARD_CHECK);
            state.sessionState.tryAgainAfterFailure = false;
            state.deviceReadinessState.validationState = "Completed"
            state.deviceReadinessState.deviceReadinessInfo= {
                readinessCheckStartedAt : state.deviceReadinessState.deviceReadinessInfo?.readinessCheckStartedAt || new Date().toISOString(),
                failureReason:failedChecks,
                deviceReadinessCheckPassed:failedChecks.length> 0 ? false: true,
                readinessCheckCompletedAt: new Date().toISOString(),
                state:"ReadinessCheckCompleted"

            }
            state.deviceReadinessSummary= state?.deviceReadinessSummary ? ({
                    deviceName: state.deviceState.deviceId || "NotAvailable",
                    status: failedChecks?.length > 0 ? "Failure" : "Success",
                    responses:[...action.payload,...state.deviceReadinessSummary.responses] 
                } as IValidationSummary) : ({
                    deviceName: state.deviceState.deviceId || "NotAvailable",
                    status: failedChecks?.length > 0 ? "Failure" : "Success",
                    responses: [...action.payload]
                } as IValidationSummary)
            
        },
        createSetCached(state:IADPState,action:{type:string,payload:CachedType}){
            state.appState.isCached= action.payload
        },
        createSetExpectedVersion(state:IADPState,action:{type:string,payload:{component: eNAEPComponents,version:string}}){
            switch (action.payload.component) {
                case eNAEPComponents.ADC:
                    state.appState.expectedADCVersion = action.payload.version
                    break;
                    case eNAEPComponents.ADP:
                    state.appState.expectedADPVersion = action.payload.version
                    break;
                    case eNAEPComponents.SCI:
                    state.appState.expectedSCIVersion = action.payload.version
                    break;
                    case eNAEPComponents.CHROME_EXTENSION:
                    state.appState.extensionVersion = action.payload.version
                   
                    break;
            }
        },
        createUpdateDeviceStateAction(state:IADPState,action:{type:string,payload:Record<string, unknown>}){
            const deviceDetails= action.payload as SessionDetails;
            state.deviceState={
                ...state.deviceState,
                deviceModel: deviceDetails.deviceModel,
                systemInfo: deviceDetails.systemInfo
            }
            state.sessionState={
                ...state.sessionState,
                networkDetails: deviceDetails.networkConnectionDetails ? deviceDetails.deviceType === "NPE" ? deviceDetails.networkConnectionDetails : {...deviceDetails.networkConnectionDetails,SSID:undefined} : undefined,
               }  
        },
        
        createSetSessionDetailsAction(state:IADPState,action:{type:string,payload:Record<string, unknown>}){
            if(state.sessionState.failure){
                return;
            }
            const sessionDetails= action.payload as SessionDetails
                state.appState={
                ...state.appState,
                appLaunchId:sessionDetails.appLaunchId,
                runtimePlatform: sessionDetails.runtimePlatform,
                //currentView: getView(),
                isPageReloaded: sessionDetails.isPageReloaded,
                extensionVersion: sessionDetails.extensionVersion
               }, 
               state.sessionState={
                ...state.sessionState,
                tryAgainAfterFailure: false,
                //lastKnownGoodState: getView() === "ModeSelectionsView" ? "ModeSelectionsView" : undefined,
                networkConnectionState: sessionDetails.networkConnectionState ? sessionDetails.networkConnectionState : state.sessionState.networkConnectionState
               },
                state.deviceState={
                    ...state.deviceState,
                    deviceId: sessionDetails.deviceId,
                    deviceIdType: sessionDetails.deviceIdType,
                    deviceModel: sessionDetails.deviceModel,
                    deviceType: sessionDetails.deviceType,
                    systemInfo: sessionDetails.systemInfo
                },
                state.updateState.isCheckForUpdateEnabled= sessionDetails?.isCheckForUpdateEnabled !== undefined ? sessionDetails.isCheckForUpdateEnabled : false
        },
        createSetUpdateComponentVersionsAction(state:IADPState,action:{type:string,payload:UpdateComponents}){
            const appComponentVersionArray = [...state.updateState.appComponentVersions];
            appComponentVersionArray.push(action.payload);
            state.updateState.appComponentVersions= appComponentVersionArray
        }, 
        createSetBatteryAction(state:IADPState,action:{type:string,payload:Battery}){
            const batteryPayload = action.payload;
            state.deviceState.batteryState=batteryPayload
        },
        createSetExitAction(state:IADPState){
            window.close()
            //TODO see if we need to capture anything else befoer we close the app Also moving forward use this action instead of window.close so we can control the behavior
        }, 
        createSetHomeAction(state:IADPState){
            state.sessionState.schoolDetails = undefined;
            state.sessionState.appAccessedFor = "NotSelected"
            state.sessionState.selectedAssessmentLocation = undefined;
            state.sessionState.lastKnownGoodState = "ModeSelectionsView"
            state.deviceReadinessSummary = undefined;
            state.sessionState.providedCode = undefined;
            state.sessionState.locationError = false;
            state.deviceReadinessState.validationState=undefined;
            state.sessionState.exitButtonEnabled=true;
            state.sessionState.homeButtonEnabled=false;
            state.appState.currentView = "ModeSelectionsView";
            state.sessionState.failure = undefined
            state.sessionState.confirmationModal = false;

        }, 
        createTryAgainAction(state:IADPState){
            state.deviceReadinessState.validationState=undefined;
            state.sessionState.confirmationModal = false;
            state.sessionState.tryAgainAfterFailure = true;
            state.sessionState.failure = undefined;
        }, 
        createSetSwitchLanguage(state:IADPState,action:{type:string,payload:'en' | 'es'}){
            if(state.staticContent)state.currentLanguageContent = state.staticContent[action.payload];
            state.appState.selectedLanguage = action.payload
        }, 
        createSetDeviceVitalsInfo(state:IADPState,action:{type:string,payload:DeviceVitalsInfo[]}){
            const results = action.payload;
            state.deviceReadinessState.deviceVitalsInfo= results
        },
        createFailureAction(state:IADPState,action:{type:string,payload:FailureType}){
                const results = action.payload;
                state.sessionState.failure= results;
                state.sessionState.exitButtonEnabled=true;
                state.sessionState.homeButtonEnabled=false;
                state.appState.currentView = "FailureView";
                state.sessionState.tryAgainAfterFailure = false;
        },
        createSetConfirmationModalAction(state:IADPState,action:{type:string,payload:boolean}){
            if(state.sessionState.failure){
                return;
            }
            const results = action.payload;
            state.sessionState.confirmationModal = results;
        },
        createSetRelaunchInformation(state:IADPState,action:{type:string,payload:RelaunchInformationType}){
            const results = action.payload;
            state.appState.relaunchInformation = results;
            state.appState.relaunchInformation.clientLaunchId = results.clientLaunchId ? results.clientLaunchId : "NotAvailable",
            state.appState.relaunchInformation.loginId = results.loginId ? results.loginId : "NotAvailable",
            state.appState.relaunchInformation.reason = results.reason ? results.reason : "NotAvailable"

        },
        createLaunchFailureAction(state:IADPState,action:{type:string,payload:LaunchErrorType}){
            state.sessionState.launchError = action.payload;
        },
        createSetServerDetails(state:IADPState,action:{type:string,payload:string}){
            state.appState.serverDetails = action.payload;
        },
             
            
    }
})
export const { 
    createSetLaunchMode,
    createSetResourcesLoaded,
    createSetDateTimeCheck,
    createSetConfigAction,
    createSetContentAction,
    createSetInitialStateAction,
    createSetViewAction,
    createSetReleaseVersionAction,
    createUpdateServiceWorkerDetailsAction,
    createUpdatePreChacheValidationStatusAction,
    createSetNetworkAction,createSetNetworkDetails,
    createUpdateProgressAction,
    createUpdateSchoolAction,
    createSetAssessmentModeAction, 
    createValidationAction,
    createSetDeviceReadinessSummary,
    createSetSessionDetailsAction,
    createSetUpdateComponentVersionsAction,
    createSetBatteryAction,createSetExitAction,
    createSetHomeAction,
    createTryAgainAction,
    createSetSwitchLanguage,
    createSetDeviceVitalsInfo, 
    createSetUpdateManfiestAction, 
    createSetCached, 
    createSetConfirmationModalAction, 
    createRedirectToSCI,
    createSetExpectedVersion,
    createSetServiceWorkerRegAction,
    createUpdateStatusAction,
    createUpdateDeviceStateAction,
    createFailureAction,
    createSetRelaunchInformation,
    createLaunchFailureAction,
    createSetMaintenance,
    createSetServerDetails,
    createClearSchoolAction  } = reducerSlice.actions
export default reducerSlice.reducer
